import { sendPost } from '@utils/request';

// 创建订单
export function createOrder(data) {
  const url = '/trade/orderContract/createOrder';
  return sendPost({ url, data, specielApi: true });
}

// 新创建订单
export function newCreateOrder(data) {
  const url = '/trade/entity/createOrder';
  return sendPost({ url, data, specielApi: true });
}

// 获取确认订单页面获取订单列表信息
export function confirmOrder(data) {
  const url = '/v2/trade/confirmOrder';
  return sendPost({ url, data});
}

// 获取订单列表
export function getOrderList(data) {
  const url = '/trade/userOrderContract/orderlist/forPC';
  return sendPost({ url, data });
}

// 获取订单详情
export function getOrderDetails(data) {
  const url = '/trade/userOrderContract/orderdetail';
  return sendPost({ url, data });
}

// 取消订单
export function cancelOrder(data) {
  const url = '/tradeCancelDeliveryOrderContract/cancelDeliveryOrder/forUser';
  return sendPost({ url, data });
}
// 删除订单
export function deleteOrder(data) {
  const url = '/order/userOrderContract/deleteOrder';
  return sendPost({ url, data });
}
// 用户退款，取消运单
export const fetchcancelDelivery = (data) => {
  const url = '/tradeCancelDeliveryOrderContract/cancelDeliveryOrder/forUser';
  return sendPost({
    url, data, method:'POST',
    baseURL:true,
    applicationType:true,
    deleteFalsyProp:true,
    Business:true,
    specielApi:true});
};

// 获取新支付url
export const getPayUrl = (data) => {
  const url = 'omsOrder/payment/getPayUrl';
  return sendPost({url, data});
};

// 电子劵新支付url
export function goPayUrl(data, uid) {
  const url = `payment/getNewPayUrl?channel=2&uid=${uid}`;
  return sendPost({url, data});
}

// 获取移动端二维码
export function getQrcodeUrl(data) {
  const url = '/mini/api/qrcode/commonGenerate';
  return sendPost({ url, data,
    method: 'POST',
    baseURL: true,
    applicationType: true,
    deleteFalsyProp: true,
    imgType: true,
    Business: true,
    specielApi: false,
  });
}

// 查询用户信息(是否已绑定手机号,是否已设置支付密码)
export const getUserInfoHandle = data => {
  const url = 'user/info/external/morequery';
  return sendPost({ url, data });
};

// 绑定手机号(更新手机号)
export const bindMobileHandle = data => {
  const url = 'user/info/external/mobile/update';
  return sendPost({ url, data });
};
// 获取短信验证码
export const getSmsHandle = data => {
  const url = '/usercoord/sms/external/create';
  return sendPost({ url, data });
};

// 短信验证码校验
export const valiSmsHandle = data => {
  const url = 'usercoord/sms/external/validate';
  return sendPost({ url, data });
};

// 绑定手机号新接口
export const updateMobileHandle = data => {
  const url = 'user/info/external/mobile/update';
  return sendPost({ url, data });
};

// 设置/更新支付密码
export const setPaymentPwdHandle = data => {
  const url = '/user/info/external/paypassword/update';
  return sendPost({ url, data });
};

// 支付密码验证
export const validatePaymentPwdHandle = data => {
  const url = '/user/info/external/paypassword/validate';
  return sendPost({ url, data },true);
};

// 绑卡验证
export const bindCardValidateHandle = data => {
  const url = '/usercoord/usercard/external/validate';
  return sendPost({ url, data });
};

// 绑卡
export const bindCardHandle = data => {
  const url = '/usercoord/usercard/external/bind';
  return sendPost({ url, data });
};

// 获取福利卡、用户余额、积分信息
export function getInterestsInfo(data) {
  const url = '/trade/orderapi/interestsInfo';
  return sendPost({ url, data });
}

// 获取福利卡、用户余额、积分信息
export function unavailableQuery(data) {
  const url = '/rightcenter/unavailable/query';
  return sendPost({ url, data });
}


// 选卡计算剩余支付金额
export function choosePaymentWay(data) {
  const url = '/trade/orderapi/choosePaymentWay';
  return sendPost({ url, data });
}

/**
 * 开通免密支付
 */
export function openFreePay(data) {
  const url = '/user/tags/external/set';
  return sendPost({ url, data });
}

/**
 * 获取精准配送的日历
 */
export function POST_getPreciseDeliveryDate(data) {
  const url = '/trade/orderapi/getPreciseDeliveryDate';
  return sendPost({ url, data });
}

/*
* 获取精准配送的可选时间段
*/
export function POST_getPreciseDeliveryTime(data) {
  const url = '/trade/orderapi/getPreciseDeliveryTime';
  return sendPost({ url, data });
}

